import { Link } from "react-router-dom";
import { ImageOff } from "lucide-react";

function Group({ title, items, to, testId }) {
  if (!items.length) return null;
  return (
    <div>
      <Link to={to} className="text-sm font-semibold text-[#0f2544] hover:text-[#1f44e0]" data-testid={testId}>{title} ({items.length}) →</Link>
      <ul className="mt-2 flex flex-wrap gap-2">
        {items.map((t, k) => <li key={`${t}-${k}`} className="rounded-full bg-[#fdf3e1] border border-[#e6c364]/50 px-3 py-1 text-xs text-[#0f2544]">{t}</li>)}
      </ul>
    </div>
  );
}

export function ExternalImages({ data }) {
  if (!data || (!data.libros.length && !data.autores.length)) return null;
  return (
    <div className="mt-8 rounded-xl bg-white border border-[#e6c364]/60 p-6" data-testid="external-images">
      <h3 className="flex items-center gap-2 font-serif text-xl text-[#0f2544]"><ImageOff size={18} className="text-[#b8860b]" /> Imágenes de la web antigua</h3>
      <p className="text-sm text-[#4a4a45] mt-1 mb-5">Estas imágenes siguen enlazadas a la web antigua y pueden no verse. Abre cada uno, vuelve a subir la imagen y guarda: quedará en tu almacenamiento.</p>
      <div className="space-y-5">
        <Group title="Portadas de libros" items={data.libros} to="/admin/libros" testId="external-images-libros" />
        <Group title="Fotos de autores" items={data.autores} to="/admin/autores" testId="external-images-autores" />
      </div>
    </div>
  );
}
